const state = () => {
    return {
        remember: false,
        token: null,
        expiry: null,
        current_user: {
            id: null,
            firstName: null,
            lastName: null,
            userName: null,
            email: null,
            roles: []
        }
    }
}
export default state
